// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/SecurityDisclosurePage.js).
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "../../ui/button";
import { Page, H1, H2, Lead, P, UL, Notice } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const SecurityDisclosurePage = () => (
  <Page testid="security-disclosure-page">
    <H1>Vulnerability reporting</H1>
    <Lead>
      Do you think you have discovered a security flaw in SecurePass? We welcome responsible reports and
      thank you for them.
    </Lead>

    <H2 id="comment">How to report</H2>
    <P>
      Send your report via the
      <Link to="/contact?subject=security" className="text-emerald-600 underline"> Contact page</Link>
      {legal.securityEmail ? <> or to {legal.securityEmail}</> : null}. No dedicated security email
      address is published until one is configured.
    </P>
    <div className="mt-4">
      <Link to="/contact?subject=security">
        <Button data-testid="security-report-btn" className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
          <ShieldAlert className="w-4 h-4 mr-2" /> Report a vulnerability
        </Button>
      </Link>
    </div>

    <H2 id="informations">Useful information</H2>
    <UL>
      <li>Description of the vulnerability and its potential impact.</li>
      <li>Clear reproduction steps.</li>
      <li>Component, URL or request concerned.</li>
      <li>Your contact details for any follow-up.</li>
    </UL>

    <H2 id="regles">Responsible disclosure rules</H2>
    <UL>
      <li>Never include a real secret in your report.</li>
      <li>Do not exfiltrate data or infringe the privacy of others.</li>
      <li>Do not deliberately disrupt the service (no denial of service, no destruction).</li>
      <li>Act in good faith.</li>
      <li>Allow a reasonable time for analysis and remediation before any publication.</li>
    </UL>

    <Notice testid="security-disclosure-note">
      SecurePass does not promise a reward programme (bug bounty), payment, absolute legal immunity or a
      guaranteed response time. Every good-faith report is nevertheless examined seriously.
    </Notice>
  </Page>
);

export default SecurityDisclosurePage;
